var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.992 1C4.576 1 1 4.584 1 9C1 13.416 4.576 17 8.992 17C13.416 17 17 13.416 17 9C17 4.584 13.416 1 8.992 1ZM14.536 5.8H12.176C11.9252 4.80929 11.5545 3.85288 11.072 2.952C12.5313 3.4544 13.7609 4.46538 14.536 5.8ZM9 2.632C9.664 3.592 10.184 4.656 10.528 5.8H7.472C7.816 4.656 8.336 3.592 9 2.632ZM2.808 10.6C2.68 10.088 2.6 9.552 2.6 9C2.6 8.448 2.68 7.912 2.808 7.4H5.512C5.448 7.928 5.4 8.456 5.4 9C5.4 9.544 5.448 10.072 5.512 10.6H2.808ZM3.464 12.2H5.824C6.08 13.2 6.448 14.16 6.928 15.048C5.46764 14.5475 4.23739 13.536 3.464 12.2ZM5.824 5.8H3.464C4.23739 4.46396 5.46764 3.45249 6.928 2.952C6.44551 3.85288 6.07476 4.80929 5.824 5.8ZM9 15.368C8.336 14.408 7.816 13.344 7.472 12.2H10.528C10.184 13.344 9.664 14.408 9 15.368ZM10.872 10.6H7.128C7.056 10.072 7 9.544 7 9C7 8.456 7.056 7.92 7.128 7.4H10.872C10.944 7.92 11 8.456 11 9C11 9.544 10.944 10.072 10.872 10.6ZM11.072 15.048C11.552 14.16 11.92 13.2 12.176 12.2H14.536C13.7609 13.5346 12.5313 14.5456 11.072 15.048ZM12.488 10.6C12.552 10.072 12.6 9.544 12.6 9C12.6 8.456 12.552 7.928 12.488 7.4H15.192C15.32 7.912 15.4 8.448 15.4 9C15.4 9.552 15.32 10.088 15.192 10.6H12.488Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.c13e14fa5e27678e0782e4054f8b9455.svg";
export { ForwardRef as ReactComponent };